import { PropsWithChildren, ReactNode } from "react";
import Footer from "./Footer";
import Header from "./Header";
import "./AppLayout.css";

type AppLayoutProps = PropsWithChildren<{
  title?: ReactNode;
  subtitle?: string;
  headerRight?: ReactNode;
}>;

export default function AppLayout({
  title,
  subtitle,
  headerRight,
  children,
}: AppLayoutProps) {
  return (
    <div className="app">
      <Header />

      <main className="site-main">
        <div className="page">
          {(title || subtitle) && (
            <div className="page-header">
              {title && (
                <div className="page-header-top">
                  <h1>{title}</h1>
                  {headerRight}
                </div>
              )}
              {subtitle && <p>{subtitle}</p>}
            </div>
          )}
          <div className="page-content">{children}</div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
